var _fontWeights, _fontSizes, _lineHeights, _paddingsX;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Tone, Size } from "./Chip.types";
import { getAppearance } from "./Chip.colors";
export var getChipStyle = function getChipStyle(_ref) {
  var palette = _ref.palette,
      tone = _ref.tone,
      size = _ref.size,
      appearance = _ref.appearance;
  return _objectSpread({
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 2,
    py: 1,
    px: paddingsX[size],
    lineHeight: lineHeights[size],
    fontSize: fontSizes[size],
    fontWeight: fontWeights[tone]
  }, getAppearance(tone, palette, appearance));
};
/** TODO
 * Current implementation accepts React Child and wraps it in a styled box.
 * We're mapping chip sizes to absolute pixel values. This is not right.
 * Ideal implementation would be to accept a label prop, render it using Text (src/core/Text)
 * and map chip sizes to design system-specific relative units use the value for
 * fontSize, lineHeight and paddingX
 */

var fontWeights = (_fontWeights = {}, _defineProperty(_fontWeights, Tone.dark, 'medium'), _defineProperty(_fontWeights, Tone.light, 'normal'), _fontWeights);
var fontSizes = (_fontSizes = {}, _defineProperty(_fontSizes, Size.small, '10px'), _defineProperty(_fontSizes, Size.medium, '12px'), _fontSizes);
var lineHeights = (_lineHeights = {}, _defineProperty(_lineHeights, Size.small, '14px'), _defineProperty(_lineHeights, Size.medium, '16px'), _lineHeights);
export var paddingsX = (_paddingsX = {}, _defineProperty(_paddingsX, Size.small, '4px'), _defineProperty(_paddingsX, Size.medium, '6px'), _paddingsX);
export var leftIconSizes = {
  medium: 'medium',
  small: 'small'
};
export var rightIconSizes = {
  medium: 'small',
  small: 'xSmall'
};